import {
  GROUP_SUCCESS,
  GROUP_CREATE,
  GROUP_DELETE,
  GROUP_EDIT
} from '../types'

const initialState = {
  isFetching: false,
  list: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GROUP_SUCCESS:
      return {
        ...state,
        list: action.payload
      }

    case GROUP_CREATE:
      return {
        ...state,
        list: [
          ...state.list,
          action.payload
        ]
      }

    case GROUP_DELETE:
      return {
        ...state,
        list: state.list.filter((group) => group.id !== action.payload.id)
      }

    case GROUP_EDIT:
      return {
        ...state,
        list: [
          ...state.list.map(group => group.id === action.payload.id ? action.payload : group)
        ]

      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/group.js